module.exports = __webpack_public_path__ + "static/media/accolade.ad6e09f4.png";